(function (scope) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintController2D} controller
   * @param {Design} design
   */
  var PrintReview2DView = (scope.PrintReview2DView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;

    this.$el = $("#lasercut-legend-review");

    this.is_actived = false;
    this.is_measureActive = true;
    this.newScale = null;

    this.$el.on(
      "click",
      "#lasercut-distance-button",
      this.updateMeasureScale.bind(this)
    );
    this.$el.on(
      "change",
      "#lasercut-distance-input",
      this.setDistanceScale.bind(this)
    );
    this.$el.on(
      "click",
      'input[name="switch-measure"]',
      this.switchMeasure.bind(this)
    );
  });

  /**
   * enable review
   * @public
   */
  PrintReview2DView.prototype.enabled = function () {
    this.is_actived = true;
    this.toggleMeasure();
    this.toggleIssues();
    this.updateUnit();
  };

  /**
   * disable review
   * @public
   */
  PrintReview2DView.prototype.disabled = function () {
    this.is_actived = false;
    SvgViewer.setMeasuringMode(false);

    SvgViewer.hideIssues();
    $("#lasercut-issues-widget").hide();
  };

  /**
   * update unit
   * @public
   */
  PrintReview2DView.prototype.updateUnit = function () {
    $(".unit", this.$el).html(this.design.size.unit);
  };

  /**
   * activate or disabled the measure tool
   * @public
   */
  PrintReview2DView.prototype.switchMeasure = function () {
    if ($('input[name="switch-measure"]', this.$el).is(":checked")) {
      this.is_measureActive = true;
      $(".lasercut-measure-switch span", this.$el).html(
        $(".lasercut-measure-switch span", this.$el).data("on")
      );
    } else {
      this.is_measureActive = false;
      $(".lasercut-measure-switch span", this.$el).html(
        $(".lasercut-measure-switch span", this.$el).data("off")
      );
    }

    //display or hide measure line based on the var is_measureActive
    this.toggleMeasure();
  };

  /**
   * set in a var the new scale
   * @public
   */
  PrintReview2DView.prototype.setDistanceScale = function () {
    var clean = function (val) {
      return parseFloat(val.replace(/,/g, ".").replace(/([^0-9\.])/g, "")); // Strip out nonsense characters
    };
    var cleanVal = clean($("#lasercut-distance-input").val());

    this.newScale =
      (cleanVal * SvgViewer.getScale()) / SvgViewer.getMeasureLine();
    this.newScale = this.newScale.toFixed(11);
  };

  /**
   * update the scale with the new scale
   * @public
   */
  PrintReview2DView.prototype.updateMeasureScale = function () {
    //only if not null
    if (this.newScale !== null && this.newScale != 0) {
      this.controller.updateScale(this.newScale);
      $("#lasercut-distance-input").val("");
    }
  };

  /**
   * display or hide the measure line and disabled/enabled the input and button
   * @public
   */
  PrintReview2DView.prototype.toggleMeasure = function () {
    if (this.is_measureActive) {
      SvgViewer.hideIssues();
      SvgViewer.setMeasuringMode(true);

      //set the input to null
      $("#lasercut-distance-input").val("");

      $(".lasercut-distance-groups").removeClass("disabled");
    } else {
      SvgViewer.setMeasuringMode(false);
      SvgViewer.setScaleCheckMode(false);
      this.toggleIssues();
      $(".lasercut-distance-groups").addClass("disabled");
    }
  };

  /**
   * display or hide the issues based on the current material
   * only for metal right now
   * @public
   */
  PrintReview2DView.prototype.toggleIssues = function () {
    if (this.is_actived == false) return;

    if (SvgViewer.hasIssues()) {
      SvgViewer.displayIssues();
      $("#lasercut-issues-widget").show();
    } else {
      SvgViewer.hideIssues();
      $("#lasercut-issues-widget").hide();
    }
  };
})((window.sculpteo = window.sculpteo || {}));
